import React from "react";
import "./ServiceHero.css";
import { Link } from "react-router-dom";
import { FaArrowRight, FaPhoneAlt, FaCheckCircle } from "react-icons/fa";

const ServiceHero = ({ data }) => {
  if (!data) {
    return null;
  }

  // =====================================================
  // SAFE DATA
  // =====================================================

  const title = data.title || "Professional Sports Construction";

  const subtitle =
    data.subtitle ||
    data.shortDescription ||
    "Premium sports surfaces engineered for performance, durability and long-term value.";

  const heroImage =
    data.heroImage || data.coverImage || data.coverImageUrl || data.image || "";

  const breadcrumb = Array.isArray(data.breadcrumb)
    ? data.breadcrumb
    : ["Home", "Services", title];

  const heroStats = Array.isArray(data.heroStats) ? data.heroStats : [];

  // =====================================================
  // BUTTON HANDLERS
  // =====================================================

  const handleQuote = () => {
    const quoteSection =
      document.getElementById("quote") ||
      document.getElementById("contact") ||
      document.getElementById("get-quote");

    if (quoteSection) {
      quoteSection.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const handleCall = () => {
    window.location.href = "tel:+919533634708";
  };

  return (
    <section
      className="service-hero"
      style={
        heroImage
          ? {
              backgroundImage: `url("${heroImage}")`,
            }
          : {}
      }
    >
      {/* =================================================
          BACKGROUND
      ================================================= */}

      <div className="service-hero-background"></div>

      {/* =================================================
          DARK GRADIENT OVERLAY
      ================================================= */}

      <div className="hero-overlay"></div>

      {/* =================================================
          DECORATIVE ELEMENTS
      ================================================= */}

      <div className="hero-grid"></div>

      <div className="hero-glow hero-glow-one"></div>

      <div className="hero-glow hero-glow-two"></div>

      {/* =================================================
          CONTENT
      ================================================= */}

      <div className="hero-container">
        {/* =================================================
            BREADCRUMB
        ================================================= */}

        <div className="hero-breadcrumb">
          {breadcrumb.map((item, index) => (
            <React.Fragment key={index}>
              <span
                className={
                  index === breadcrumb.length - 1 ? "breadcrumb-current" : ""
                }
              >
                {item}
              </span>

              {index !== breadcrumb.length - 1 && (
                <span className="breadcrumb-divider">/</span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* =================================================
            SMALL LABEL
        ================================================= */}

        <div className="hero-eyebrow">
          <span className="eyebrow-line"></span>

          <FaCheckCircle />

          <span>PROFESSIONAL SPORTS SURFACE SOLUTIONS</span>

          <span className="eyebrow-line"></span>
        </div>

        {/* =================================================
            MAIN HEADING
        ================================================= */}

        <h1 className="service-hero-title">{title}</h1>

        {/* =================================================
            SUBTITLE
        ================================================= */}

        {subtitle && <p className="service-hero-subtitle">{subtitle}</p>}

        {/* =================================================
            BUTTONS
        ================================================= */}

        <div className="hero-buttons">
          <button
            className="hero-btn hero-btn-primary"
            type="button"
            // onClick={handleQuote}
          >
            <Link to="/contact">Get Free Quote</Link>

            <FaArrowRight />
          </button>

          <button
            className="hero-btn hero-btn-secondary"
            type="button"
            onClick={handleCall}
          >
            <FaPhoneAlt />

            <span>Schedule Site Visit</span>
          </button>
        </div>

        {/* =================================================
            STATS
        ================================================= */}

        {heroStats.length > 0 && (
          <div className="hero-stats">
            {heroStats.map((item, index) => {
              if (!item) {
                return null;
              }

              return (
                <div className="hero-stat" key={index}>
                  <div className="hero-stat-value">{item.value || "—"}</div>

                  <div className="hero-stat-label">{item.label || ""}</div>
                </div>
              );
            })}
          </div>
        )}

        {/* =================================================
            SCROLL INDICATOR
        ================================================= */}

        <button
          className="scroll-indicator"
          type="button"
          onClick={() => {
            window.scrollBy({
              top: window.innerHeight * 0.75,
              behavior: "smooth",
            });
          }}
        >
          <span className="scroll-mouse">
            <span className="scroll-wheel"></span>
          </span>

          <span className="scroll-text">EXPLORE</span>

          <span className="scroll-arrow">↓</span>
        </button>
      </div>
    </section>
  );
};

export default ServiceHero;
